import React from 'react';
import EventsManager from '@/features/cms/components/EventsManager';

const CmsEventsPage: React.FC = () => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
    <EventsManager />
  </div>
);

export default CmsEventsPage;
